//Variable Declaration
const petSelect = document.querySelector("#btnOunces");
const petNameInput = document.querySelector("#inputName");
const petAgeInput = document.querySelector("#inputAge");
const petWeightInput = document.querySelector("#inputPounds");

/*
//Con esto obtenemos la informacion del producto

fetch(window.Shopify.routes.root + 'products/IDDELPRODUCTOXD.js')
  .then(response => response.json())
  .then(product => console.log(product));

  

*/

//Validate Introduced Data
function validateData(){
  
  let petName = petNameInput.value;
  let petweight = petWeightInput.value;
  let petAge = petAgeInput.value;
  
  if (petName === "") {
    alert("Please enter your pet's name");
    return;
  } else if (petAge === "") {
    alert("Please enter your pet's age");
    return;
  } else if (petweight === "") {
    alert("Please enter your pet's weight");
    return;
  } else {
    petPortions(petweight);
  }
}

//Calculate if u click on button
petSelect.addEventListener("click", (event) => validateData());

//Calculate if u hit enter
function validation(event){ if (event.key === "Enter") { validateData(); } }

//Go down
const clickedBanner = document.querySelector('.banner__heading');
  const formPosition = petNameInput.getBoundingClientRect().top + window.scrollY;
  const scrollToForm = formPosition - 155;
    clickedBanner.addEventListener('click', () =>{
    window.scrollTo({
  top: scrollToForm,
  behavior: "smooth"
});
  } )

//Nidia de esos 3
petNameInput.addEventListener("keyup", (event) => {validation(event)});
petAgeInput.addEventListener("keyup", (event) => {validation(event)});
petWeightInput.addEventListener("keyup", (event) => {validation(event)});

//Calculator
function petPortions(petweight) {

  let petweightrounded = Math.round(petweight);

  let petKg = petweightrounded / 2.2;
  let metabolicPet = Math.pow(petKg, 0.75);
  let caloriesPet = 70 * metabolicPet;
  let mer = caloriesPet * 1.2;

  let chickenGrams = mer / 1.27;
  let rounderChickenGrams = Math.round(chickenGrams);
  let ouncesperDayChicken = Math.round(rounderChickenGrams / 28.35);
  let ouncesperWeekChicken = ouncesperDayChicken * 7;
  let ouncesperMonthChicken = ouncesperDayChicken * 30;

  let beefGram = mer / 1.2;
  let roundedBeefGrams = Math.round(beefGram);
  let ouncesperDayBeef = Math.round(roundedBeefGrams / 28.35);
  let ouncesperWeekBeef = ouncesperDayBeef * 7;
  let ouncesperMonthBeef = ouncesperDayBeef * 30;

  let turkeyGram = mer / 1.27;
  let roundedTurkeyGrams = Math.round(turkeyGram);
  let ouncesperDayTurkey = Math.round(roundedTurkeyGrams / 28.35);
  let ouncesperWeekTurkey = ouncesperDayTurkey * 7;
  let ouncesperMonthTurkey = ouncesperDayTurkey * 30;

  let porkGram = mer / 1.32;
  let roundedPorkGrams = Math.round(porkGram);
  let ouncesperDayPork = Math.round(roundedPorkGrams / 28.35);
  let ouncesperWeekPork = ouncesperDayPork * 7;
  let ouncesperMonthPork = ouncesperDayPork * 30;

  let lambGram = mer / 1.35;
  let roundedLambGrams = Math.round(lambGram);
  let ouncesperDayLamb = Math.round(roundedLambGrams / 28.35);
  let ouncesperWeekLamb = ouncesperDayLamb * 7;
  let ouncesperMonthLamb = ouncesperDayLamb * 30;
  

  if (roundedBeefGrams < 10) {
    ouncesperDayBeef = ouncesperDayBeef.toString().padStart(2, "0");
  }

  if (rounderChickenGrams < 10) {
    ouncesperDayChicken = ouncesperDayChicken.toString().padStart(2, "0");
  }

   if (roundedTurkeyGrams < 10) {
    ouncesperDayTurkey = ouncesperDayTurkey.toString().padStart(2, "0");
  }

if (roundedLambGrams < 10) {
    ouncesperDayLamb = ouncesperDayLamb.toString().padStart(2, "0");
  }

  if (roundedPorkGrams < 10) {
    ouncesperDayPork = ouncesperDayPork.toString().padStart(2, "0");
  }

   let petPackage = '';

if (petKg < 17.5){
  petPackage = 8;

} else {
petPackage = 16;
}

  
  

let packChickenDay = Math.round(ouncesperDayChicken / petPackage); 
let packChickenWeek = Math.round(ouncesperWeekChicken / petPackage);
let packChickenMonth = Math.round(ouncesperMonthChicken / petPackage);

let packBeefDay = Math.round(ouncesperDayBeef / petPackage);
let packBeefWeek = Math.round(ouncesperWeekBeef / petPackage);
let packBeefMonth = Math.round(ouncesperMonthBeef / petPackage);

let packTurkeyDay = Math.round(ouncesperDayTurkey / petPackage);
let packTurkeyWeek = Math.round(ouncesperWeekTurkey / petPackage);
let packTurkeyMonth = Math.round(ouncesperMonthTurkey / petPackage);

  let packLambDay = Math.round(ouncesperDayLamb / petPackage);
let packLambWeek = Math.round(ouncesperWeekLamb / petPackage);
let packLambMonth = Math.round(ouncesperMonthLamb / petPackage);

    let packPorkDay = Math.round(ouncesperDayPork / petPackage);
let packPorkWeek = Math.round(ouncesperWeekPork / petPackage);
let packPorkMonth = Math.round(ouncesperMonthPork / petPackage);
  
  const petName = document.querySelector("#inputName").value;
  let petNameUppercase= petName.charAt(0).toUpperCase()+petName.slice(1)
  let portions = document.querySelector(".portionsRecommended");

    let packRecommend = document.querySelector(".packRecommended");
  
  portions.innerHTML = "";
  portions.innerHTML = `
  <div class='title'><img src="//720d49.myshopify.com/cdn/shop/t/22/assets/dogLogo_1024x1024.png?v=156100838573458930331773081607" alt="logo"><h2>${petNameUppercase}</h2></div>
<p>it’s recommended to eat X servings per day (depending on the dog's activity level). We're excited to offer you a Starter Plan featuring the following flavors:</p>

<div id="div-res-calc">
    <div> <img id="dogpack" src="https://www.keycanfood.com/cdn/shop/t/6/assets/dogPack_1024x1024.png?v=65881505842825765911715903643"> </div>    
    <div>
        <div class="suggested-calculator">
            <img src="https://cdn.shopify.com/s/files/1/0767/5192/9639/files/CARNE_S_1.png?v=1716662853">
            <div>
                <tittle id="ti_beef">Beef and Sweet Potato</tittle>
                <p>Savory beef, nutrient-rich sweet potatoes, rice, and a blend of veggies: carrots, cauliflower and Broccoli. Enriched with omega-3, omega-6, and essential supplements.</p>
                <div>
                    <span>$35.16<durat>per week</durat></span>
                    <button>Checkout</button>
                </div>
            </div>
        </div>

        <div class="suggested-calculator">
            <img src="https://cdn.shopify.com/s/files/1/0767/5192/9639/files/Pollo_s_1.png?v=1716662856">
            <div>
                <tittle id="ti_chic">Chicken and Brown Rice</tittle>
                <p>Wholesome chicken, brown rice, and a medley of veggies: carrots, cauliflower and Broccoli.  Enriched with omega-3, omega-6, and essential supplements.</p>
                <div>
                    <span>$26.37<durat>per week</durat></span>
                    <button>Checkout</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="foot-dog-calc"></div>
      
`;
  const portionsPosition = portions.getBoundingClientRect().top + window.scrollY;
const scrollToPosition = portionsPosition - 100;



  window.scrollTo({
  top: scrollToPosition,
  behavior: "smooth"
});
}
